// extracted by mini-css-extract-plugin
export default {"container":"Home_container__AuWwQ","loader":"Home_loader__II8DA","movies":"Home_movies__kOEtU"};